import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["className", "sides", "activeSide", "onSelection"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { IconButton } from "@jutro/components";
import { Flex } from "@jutro/layout";
import { useTranslator } from "@jutro/locale";
import { sideContentShape } from "@jutro/prop-types";
import styles from "./IconsBar.module.css";
export var IconsBar = function IconsBar(_ref) {
  var className = _ref.className,
    sides = _ref.sides,
    activeSide = _ref.activeSide,
    onSelection = _ref.onSelection,
    other = _objectWithoutProperties(_ref, _excluded),
    classes = cx(styles.iconsBar, className),
    translator = useTranslator(),
    getIconClassName = function getIconClassName(sideId) {
      return cx(_defineProperty({}, styles.activeIcon, sideId === activeSide));
    };
  return React.createElement(Flex, _extends({
    className: classes,
    role: "tablist",
    direction: "column"
  }, other), _mapInstanceProperty(sides).call(sides, function (_ref2, index) {
    var icon = _ref2.icon,
      label = _ref2.label,
      id = _ref2.id,
      sideId = null != id ? id : index;
    return React.createElement(IconButton, {
      id: "right-side-icon-tab-".concat(sideId),
      key: sideId,
      className: getIconClassName(sideId),
      onClick: function onClick() {
        return onSelection(sideId);
      },
      icon: icon || "",
      role: "tab",
      "aria-controls": "right-side-panel-".concat(sideId),
      "aria-label": translator(label),
      "aria-selected": sideId === activeSide,
      noDeprecationWarnings: ["IconButton"]
    });
  }));
};
var iconsBarPropTypes = {
  className: PropTypes.string,
  sides: PropTypes.arrayOf(sideContentShape.isRequired).isRequired,
  activeSide: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelection: PropTypes.func.isRequired
};
IconsBar.propTypes = iconsBarPropTypes, IconsBar.__docgenInfo = {
  description: "The `IconsBar` component is designed as a container for Icon tabs\n\n@param {object} props properties for IconsBar component\n@returns {React.ReactElement}\n\n@metadataType container",
  methods: [],
  displayName: "IconsBar",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Additional class names for component."
    },
    sides: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "sideContentShape.isRequired"
        }
      },
      required: !0,
      description: "Array of contents and icons to display"
    },
    activeSide: {
      type: {
        name: "union",
        value: [{
          name: "number"
        }, {
          name: "string"
        }]
      },
      required: !1,
      description: "Index of the active icon in the array"
    },
    onSelection: {
      type: {
        name: "func"
      },
      required: !0,
      description: "Callback when an icon is clicked on"
    }
  }
}, IconsBar.__docgenInfo = {
  componentName: "IconsBar",
  packageName: "@jutro/router",
  description: "The `IconsBar` component is designed as a container for Icon tabs",
  displayName: "IconsBar",
  methods: [],
  actualName: "IconsBar",
  metadataType: "container",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Additional class names for component."
    },
    sides: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            id: {
              name: "string",
              description: "Id of side content trigger button",
              required: !1
            },
            label: {
              name: "custom",
              raw: "intlMessageShape.isRequired",
              description: "Label describing the content used for accessibility",
              required: !0
            },
            icon: {
              name: "string",
              description: "Icon that will represent the content on the icon bar",
              required: !1
            },
            component: {
              name: "elementType",
              description: "Component to render as content",
              required: !0
            },
            componentProps: {
              name: "shape",
              value: {},
              description: "Component props",
              required: !1
            }
          }
        }
      },
      required: !0,
      description: "Array of contents and icons to display"
    },
    activeSide: {
      type: {
        name: "union",
        value: [{
          name: "number"
        }, {
          name: "string"
        }]
      },
      required: !1,
      description: "Index of the active icon in the array"
    },
    onSelection: {
      type: {
        name: "func"
      },
      required: !0,
      description: "Callback when an icon is clicked on"
    }
  }
};